import { computed } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { LegacyCardStack } from "@shared/models/card-stack"
import type { Course, Unit } from "@shared/models/course"
import type { CourseDateCombined } from "@shared/models/course-date-combined"
import lessonViewAction from "cc-frontend/lib/actions/lesson/LESSON_VIEW"
import type Dispatcher from "cc-frontend/services/dispatcher"
import { formatCourseTime } from "cc-frontend/utils/course/times"
import { tracked } from "tracked-built-ins"
import styles from "./course-date.module.css"

interface Sig {
  Args: {
    courseDate: CourseDateCombined
    lesson: LegacyCardStack
    course: Course
    perspective: "day" | "week"
    showDate?: boolean
    planbookId: string
    websiteId?: string
    useStudentVersion: boolean
    unitsArePublic: boolean
    units: Array<Unit>
  }
}

export default class CourseDateComponent extends Component<Sig> {
  readonly styles = styles
  @service declare dispatcher: Dispatcher

  @tracked hasTrackedView = false

  @computed("args.courseDate.timeDefault")
  get hasTime() {
    return this.args.courseDate.timeDefault !== null
  }

  @computed("args.courseDate.timeCustom", "args.courseDate.timeDefault")
  get timeFormatted() {
    const time = this.args.courseDate.timeCustom ?? this.args.courseDate.timeDefault
    return formatCourseTime(time)
  }

  trackView = (cardStack) => {
    if (this.hasTrackedView === false) {
      this.dispatcher.dispatchPreparedAction(
        lessonViewAction({
          cardStackId: cardStack.id,
          lessonTitle: cardStack.attributes.title,
          planbookId: this.args.planbookId,
          courseId: this.args.course.id,
          websiteId: this.args.websiteId,
          useStudentVersion: this.args.useStudentVersion,
        })
      )
      this.hasTrackedView = true
    }
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::ClassWebsite::CourseDate": typeof CourseDateComponent
  }
}
